import { render, staticRenderFns } from "./ai-luk-video.vue?vue&type=template&id=60b31a6a&scoped=true"
import script from "./ai-luk-video.vue?vue&type=script&lang=js"
export * from "./ai-luk-video.vue?vue&type=script&lang=js"
import style0 from "./ai-luk-video.vue?vue&type=style&index=0&id=60b31a6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b31a6a",
  null
  
)

export default component.exports